// Gives every <v-snackbar> in the app a message type, so theme.css can style
// it as success / warning / error / info. Pages keep their existing
// `<v-snackbar v-model="showSnackBar">{{ msg }}</v-snackbar>` markup.
//
// The type comes from the message text; a page can also force it with
// `<v-snackbar data-tone="success">`.

const RULES = [
  ["error", /\b(fail|failed|error|wrong|couldn'?t|could not|unable|invalid|not found|denied|unauthori[sz]ed|expired|server)\b/i],
  ["warning", /\b(please|required|must|exceed|exceeds|not provided|select|enter|only|cannot|can't|no longer|before|already|missing|mismatch|do not match)\b/i],
  ["success", /\b(success|successfully|approved|uploaded|saved|updated|added|submitted|forwarded|returned|copied|sanctioned|deleted|cancelled|created|sent|completed|done)\b/i],
];

function toneFor(text) {
  for (const [tone, re] of RULES) {
    if (re.test(text)) return tone;
  }
  return "info";
}

function tag(wrapper) {
  const snack = wrapper.closest(".v-snack");
  const forced = snack && snack.getAttribute("data-tone");
  const text = (wrapper.textContent || "").trim();
  const tone = forced || toneFor(text);
  if (wrapper.getAttribute("data-tone") !== tone) wrapper.setAttribute("data-tone", tone);
}

function scan(root) {
  if (!root || !root.querySelectorAll) return;
  if (root.classList && root.classList.contains("v-snack__wrapper")) tag(root);
  root.querySelectorAll(".v-snack__wrapper").forEach(tag);
}

export default {
  install() {
    if (typeof window === "undefined" || !window.MutationObserver) return;
    const start = () => {
      scan(document.body);
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
          const wrapper = el && el.closest && el.closest(".v-snack__wrapper");
          if (wrapper) tag(wrapper);
          m.addedNodes.forEach((node) => node.nodeType === 1 && scan(node));
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.body) start();
    else document.addEventListener("DOMContentLoaded", start);
  },
};
